module.exports = "/wwwroot/img/link_list_block.png?ver=043a9216";